import { useMutation } from "@tanstack/react-query"
import { TradeDataWithoutHSCodeService } from "src/services/api/tradeDataWithoutHSCode"

export const useMutateCheckExistCTD = () => {
  return useMutation({
    mutationFn: TradeDataWithoutHSCodeService.checkExistCTD
  })
}